
    import { defineComponent } from 'vue'
    import { filterDefault } from '@/helpers/commons/filterHelper'
    import { formatDate } from '@/helpers/commons/localeHelper'
    import { iKpi } from '../../KpiScheduler'
    import Card from 'primevue/card'
    import Column from 'primevue/column'
    import DataTable from 'primevue/datatable'
    import Dialog from 'primevue/dialog'
    import kpiCardDescriptor from './KpiSchedulerKpiCardDescriptor.json'

    export default defineComponent({
        name: 'kpi-scheduler-kpi-card',
        components: { Card, Column, DataTable, Dialog },
        props: { expired: { type: Boolean }, kpis: { type: Array }, allKpiList: { type: Array } },
        emits: ['touched', 'kpiAdded', 'kpiDeleted'],
        data() {
            return {
                kpiCardDescriptor,
                kpisList: [] as iKpi[],
                filters: { global: [filterDefault] } as Object,
                selectedKpiAssociations: [] as iKpi[],
                addKpiAssociationVisible: false,
                showExpired: true
            }
        },
        created() {
            this.loadKpis()
            this.loadSelectedKpiAssociations()
        },
        methods: {
            loadKpis() {
                this.kpisList = this.kpis as iKpi[]
            },
            loadSelectedKpiAssociations() {
                if (this.kpisList) {
                    this.selectedKpiAssociations = [...this.kpisList] as iKpi[]
                }
            },
            deleteKpiAssociationConfirm(id: number) {
                this.$confirm.require({
                    message: this.$t('common.toast.deleteMessage'),
                    header: this.$t('common.toast.deleteTitle'),
                    icon: 'pi pi-exclamation-triangle',
                    accept: () => this.deleteKpiAssociation(id)
                })
            },
            deleteKpiAssociation(id: number) {
                const index = this.kpisList.findIndex((kpi: iKpi) => kpi.id === id)
                if (index > -1) {
                    const kpi = this.kpisList[index]
                    this.kpisList.splice(index, 1)
                    this.$emit('kpiDeleted', kpi)
                }
                this.loadSelectedKpiAssociations()
            },
            addKpiAssociations() {
                this.kpisList = [...this.selectedKpiAssociations]
                this.addKpiAssociationVisible = false
                this.$emit('kpiAdded', this.kpisList)
            },
            getFormattedDate(date: any) {
                return formatDate(date, 'YYYY-MM-DD')
            },
            closeKpiAssociations() {
                this.addKpiAssociationVisible = false
                this.loadSelectedKpiAssociations()
            }
        }
    })
